import {
  Button,
  Row,
  Col,
  Image,
  Dropdown,
  Menu,
  Grid,
  Drawer,
  Modal,
} from "antd";
import { useEffect, useState } from "react";
import { useMobxStores } from "../../stores/stores";
import { observer } from "mobx-react";
import { useLocation, useNavigate } from "react-router-dom";
import { keycloak } from "../../utils/keycloak";
import { constants } from "../../consts/Variables";
import CartDropdownMenu from "./CartDropdownMenu";
import UserIcon from "../../assets/user-icon.png";
import UserIconWhite from "../../assets/user-icon-white.png";
import UserIconActive from "../../assets/user-icon-active-2.png";
import UserIconWhiteActive from "../../assets/user-icon-white-active-2.png";
import MetamaskConnectedIcon from "../../assets/metamask-connected.png";
import MetamaskNotConnectedIcon from "../../assets/metamask-not-connected.png";
import {
  AppstoreOutlined,
  ContainerOutlined,
  DesktopOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  QuestionOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import Icon from "@mdi/react";
import { mdiWikipedia } from "@mdi/js";
import { mdiSchoolOutline } from "@mdi/js";
import { mdiStar } from "@mdi/js";

import { mdiShoppingOutline } from "@mdi/js";
import { mdiFolderOutline } from "@mdi/js";

import { mdiBroadcast } from "@mdi/js";
// import Icon from "@mdi/react";
import { mdiMenu } from "@mdi/js";

const { useBreakpoint } = Grid;

const MainHeader = (props) => {
  const screens = useBreakpoint();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isWideScreen, setIsWideScreen] = useState(
    () => window.innerWidth > 1600,
  );

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1601px)");
    const handler = (e) => setIsWideScreen(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);
  const isMobile = !screens.sm; // < md = mobile
  const { userStore, marketplaceStore, errorStore } = useMobxStores();
  const { pathname } = useLocation();
  const fontColor =
    pathname === "/" || pathname === "/moderation" ? "white" : "#000080";

  const getSelectedKey = (path) => {
    if (path.startsWith("/marketplace")) return "/marketplace";
    if (path.startsWith("/catalogue")) return "/catalogue";
    if (path.startsWith("/wishlist")) return "/wishlist";
    if (path.startsWith("/portfolio")) return "/portfolio";
    if (path.startsWith("/requests")) return "/requests";
    if (path.startsWith("/moderation")) return "/moderation";
    return path;
  };

  const itemsVertical = [
    {
      key: "/catalogue",
      //  icon: <ContainerOutlined />,
      label: "Catalogue",
    },
    {
      key: "marketplace-group",
      label: "Marketplace",
      // icon: <Icon path={mdiShoppingOutline} size={0.8} />,
      children: [
        {
          key: "/marketplace",
          label: "Marketplace",
          // icon: <Icon path={mdiShoppingOutline} size={0.8} />,
        },
        {
          key: "/wishlist",
          label: "Wishlist",
          // icon: <Icon path={mdiStar} size={0.8} />,
        },
        {
          key: "/portfolio",
          label: "Portfolio",
          // icon: <Icon path={mdiFolderOutline} size={0.8} />,
        },
        {
          key: "/requests",
          label: "Requests",
          // icon: <Icon path={mdiBroadcast} size={0.8} />,
        },
      ],
    },
    {
      key: "/learning-graph-tool",
      // icon: <Icon path={mdiSchoolOutline} size={0.8} />,
      label: "Learning path",
    },
    {
      key: "/community",
      //  icon: <TeamOutlined />,
      label: "Community",
    },
    {
      key: "/technical",
      label: "Wiki",
      // icon: <Icon path={mdiWikipedia} size={0.8} />,
    },

    {
      key: "/FAQ",
      // icon: <QuestionOutlined />,
      label: "FAQ",
    },
  ];
  // pick a base font size depending on breakpoint
  const mainFontSize = screens.xxl
    ? "24px"
    : screens.xl
      ? "24px"
      : screens.lg
        ? "24px"
        : screens.md
          ? 20
          : 18; // xs / small screens

  const size = screens.xxl
    ? "small"
    : screens.xl
      ? "small"
      : screens.lg
        ? "default"
        : screens.md
          ? "small"
          : "small"; // xs / small screens

  const userIsModerator =
    userStore.userRoleData?.type === "moderator" ||
    userStore.userRoleData?.type === "admin";

  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const navigate = useNavigate();

  useEffect(() => {}, [marketplaceStore.metaMaskIsConnected]);

  useEffect(() => {
    marketplaceStore.setMetaMaskIsConnected(!!localStorage.getItem("metaMask"));
  }, [marketplaceStore]);

  useEffect(() => {
    userStore.getToken();
    userStore.GetUser();
  }, [userStore, marketplaceStore]);

  function handleLocalStorageChange() {
    marketplaceStore.setMetaMaskIsConnected(!!localStorage.getItem("metaMask"));
  }
  window.addEventListener("storage", handleLocalStorageChange);

  const handleConnect = async () => {
    if (window.ethereum) {
      try {
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        if (accounts && accounts.length > 0) {
          localStorage.setItem("metaMask", accounts[0]);
          marketplaceStore.setMetaMaskIsConnected(true);
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      errorStore.setMessage("MetaMask plugin is required!");
      errorStore.setWarning(true);
    }
  };

  const handleDisConnect = async () => {
    if (localStorage.getItem("metaMask")) {
      localStorage.setItem("metaMask", "");
      marketplaceStore.setMetaMaskIsConnected(false);
    }
  };

  const requireAuth = (redirectPath, onAuthenticated) => {
    if (keycloak.authenticated) {
      onAuthenticated();
    } else {
      Modal.confirm({
        title: "Sign in required",
        content:
          "You are not allowed to perform this action. You need to sign in first.",
        okText: "Sign in",
        cancelText: "Cancel",
        onOk: () =>
          keycloak.login({
            redirectUri: window.location.origin + redirectPath,
          }),
      });
    }
  };

  const handleNavigation = (e) => {
    switch (e.key) {
      case "/wishlist":
        requireAuth("/wishlist", () => navigate("/wishlist"));
        break;
      case "/portfolio":
        requireAuth("/", () =>
          navigate(`/portfolio/${userStore.user?.username}`),
        );
        break;
      case "/community":
        window.open(constants.FORUM_URL, "_blank", "noopener,noreferrer");
        break;
      case "/technical":
        window.open(
          "https://github.com/XR2Learn/.github/wiki",
          "_blank",
          "noopener,noreferrer",
        );
        break;
      default:
        navigate(e.key);
    }
  };

  const dropdownItems = keycloak.authenticated
    ? [
        {
          key: "/logout",
          label: <Button onClick={() => props.onLogout()}>Logout</Button>,
        },
      ]
    : [
        {
          key: "/login",
          label: (
            <Button
              onClick={() =>
                keycloak.login({ redirectUri: window.location.origin + "/" })
              }
            >
              Login
            </Button>
          ),
        },
        {
          key: "/register",
          label: (
            <Button
              onClick={() =>
                keycloak.register({ redirectUri: window.location.origin + "/" })
              }
            >
              Sign Up
            </Button>
          ),
        },
      ];

  const menuItems = [
    {
      label: (
        <span
          style={{
            color: fontColor,
            // fontSize: mainFontSize,
            fontWeight: "400",
          }}
        >
          Catalogue
        </span>
      ),
      // <span style={{ color: fontColor, fontSize: "24px", fontWeight: "400" }}>
      // "Catalogue",,

      danger: false,
      disabled: false,
      key: "/catalogue",
    },
    {
      label: (
        //  (
        <span
          style={{
            color: fontColor,
            // fontSize: mainFontSize,
            fontWeight: "400",
          }}
        >
          Marketplace
        </span>
      ),
      // ),
      key: "marketplace-group",
      children: [
        {
          key: "/marketplace",
          label: (
            <span style={{ color: "white", fontSize: "20px" }}>
              Marketplace
            </span>
          ),
        },
        {
          key: "/wishlist",
          label: (
            <span style={{ color: "white", fontSize: "20px" }}>Wishlist</span>
          ),
        },
        {
          key: "/portfolio",
          label: (
            <span style={{ color: "white", fontSize: "20px" }}>Portfolio</span>
          ),
        },
        {
          key: "/requests",
          label: (
            <span style={{ color: "white", fontSize: "20px" }}>Requests</span>
          ),
        },
      ],
    },
    {
      key: "/learning-graph-tool",
      label: (
        <span
          style={{
            color: fontColor,
            // fontSize: mainFontSize,
            fontWeight: "400",
          }}
        >
          Learning Path
        </span>
      ),
      danger: false,
      disabled: false,
    },
    {
      label: (
        <span
          style={{
            color: fontColor,
            // fontSize: mainFontSize,
            fontWeight: "400",
          }}
        >
          Community
        </span>
      ),
      danger: false,
      disabled: false,
      key: "/community",
    },

    {
      label: (
        <span
          style={{
            color: fontColor,
            // fontSize: mainFontSize,
            fontWeight: "400",
          }}
        >
          Wiki
        </span>
      ),
      danger: false,
      disabled: false,
      key: "/technical",
    },
    {
      label: (
        <span
          style={{
            color: fontColor,
            // fontSize: mainFontSize,
            fontWeight: "400",
          }}
        >
          FAQ
        </span>
      ),
      danger: false,
      disabled: false,
      key: "/FAQ",
    },
  ];

  if (userIsModerator) {
    menuItems.push({
      key: "/moderation",
      label: (
        <span
          style={{
            color: fontColor,
            // fontSize: "24px",
            fontWeight: "400",
          }}
        >
          Moderation
        </span>
      ),
      danger: false,
      disabled: false,
    });
  }

  return (
    <div style={{ position: "sticky" }}>
      {isMobile ? (
        <>
          {/* Mobile top bar */}
          {/* <Row
            justify="space-between"
            align="middle"
            style={{
              padding: "8px 12px",
              background:
                pathname === "/" || pathname === "/moderation"
                  ? "#000080"
                  : "#ffffff",
            }}
          >
            <Button
              type="text"
              onClick={openDrawer}
              icon={
                <MenuUnfoldOutlined
                  style={{
                    fontSize: 24,
                    color:
                      pathname === "/" || pathname === "/moderation"
                        ? "#ffffff"
                        : "#000080",
                  }}
                />
              }
            />

            <Image
              style={{ cursor: "pointer", height: 25 }}
              onClick={() => navigate("/")}
              preview={false}
              src={
                pathname === "/" || pathname === "/moderation"
                  ? "/xr-logo-white.png"
                  : "/xr-logo.png"
              }
            />

            <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <CartDropdownMenu />
              {marketplaceStore.metaMaskIsConnected ? (
                <img
                  id="metaMaskN"
                  src={MetamaskConnectedIcon}
                  alt="metamask connected"
                />
              ) : (
                <img
                  id="metaMask"
                  onClick={() => handleConnect()}
                  // class="cart-icon"
                  // style={{ cursor: "pointer", width: 48 }}
                  src={MetamaskNotConnectedIcon}
                  alt="metamask not connected"
                />
              )}
              <Dropdown menu={{ items: dropdownItems }}>
                <img
                  onClick={(e) => e.preventDefault()}
                  src={
                    pathname === "/" || pathname === "/moderation"
                      ? keycloak.authenticated
                        ? UserIconWhiteActive
                        : UserIconWhite
                      : keycloak.authenticated
                        ? UserIconActive
                        : UserIcon
                  }
                  id="user-icon"
                  alt="user icon"
                  style={{ height: 32, width: 32, cursor: "pointer" }}
                />
              </Dropdown>
            </span>
          </Row> */}
          <Row
            justify="space-between"
            align="middle"
            style={{
              padding: "8px 12px",
              background:
                pathname === "/" || pathname === "/moderation"
                  ? "#000080"
                  : "#ffffff",
            }}
          >
            {/* LEFT: burger + logo */}
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <Button
                type="text"
                onClick={openDrawer}
                icon={
                  <Icon
                    path={mdiMenu}
                    size={1.2}
                    style={{
                      fontSize: 22,
                      color:
                        pathname === "/" || pathname === "/moderation"
                          ? "#ffffff"
                          : "#000080",
                    }}
                  />
                  // <MenuUnfoldOutlined

                  // />
                }
              />

              <Image
                style={{ cursor: "pointer", height: 25 }}
                onClick={() => navigate("/")}
                preview={false}
                src={
                  pathname === "/" || pathname === "/moderation"
                    ? "/xr-logo-white.png"
                    : "/xr-logo.png"
                }
              />
            </span>

            {/* RIGHT: cart + metamask + user */}
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <CartDropdownMenu />{" "}
              {/* if you need smaller, adjust inside that component or via CSS */}
              {marketplaceStore.metaMaskIsConnected ? (
                <img
                  id="metaMaskN"
                  src={MetamaskConnectedIcon}
                  alt="metamask connected"
                  style={{ height: 30, width: 30, cursor: "pointer" }} // smaller
                />
              ) : (
                <img
                  id="metaMask"
                  src={MetamaskNotConnectedIcon}
                  alt="metamask not connected"
                  onClick={handleConnect}
                  style={{ height: 30, width: 30, cursor: "pointer" }} // smaller
                />
              )}
              <Dropdown menu={{ items: dropdownItems }}>
                <img
                  onClick={(e) => e.preventDefault()}
                  src={
                    pathname === "/" || pathname === "/moderation"
                      ? keycloak.authenticated
                        ? UserIconWhiteActive
                        : UserIconWhite
                      : keycloak.authenticated
                        ? UserIconActive
                        : UserIcon
                  }
                  id="user-icon"
                  alt="user icon"
                  style={{ height: 30, width: 30, cursor: "pointer" }} // slightly smaller too
                />
              </Dropdown>
            </span>
          </Row>

          {/* Drawer that overlays everything */}
          {/* <Drawer
            placement="left"
            open={isDrawerOpen}
            onClose={closeDrawer}
            width={260}
            bodyStyle={{ padding: 0 }}
          >
            <Menu
              mode="inline"
              items={itemsVertical}
              selectedKeys={[getSelectedKey(pathname)]}
              onClick={(e) => {
                closeDrawer();
                handleNavigation(e);
              }}
            />
          </Drawer> */}
          <Drawer
            placement="left"
            open={isDrawerOpen}
            onClose={closeDrawer}
            width={260}
            bodyStyle={{ padding: 0, background: "#ffffff" }} // 👈 white background
          >
            <Menu
              mode="inline"
              items={itemsVertical}
              selectedKeys={[getSelectedKey(pathname)]}
              onClick={(e) => {
                closeDrawer();
                handleNavigation(e);
              }}
              className="drawer-menu" // 👈 hook for CSS
            />
          </Drawer>
        </>
      ) : (
        <Row
          style={{ padding: "8px", position: "sticky", top: "0px" }}
          justify={"space-between"}
          align={"middle"}
          className={
            pathname === "/" || pathname === "/moderation"
              ? "home-page-color"
              : "header-color"
          }
          // style={{
          //   flexDirection: "row",
          //   alignItems: "center",
          //   padding: "12px",
          //   rowGap: 0,
          // }}
        >
          <span
            id="logoPlaceholder"
            // style={{
            //   paddingLeft: isMobile ? 0 : "12px",
            //   paddingTop: 0,
            //   justifyContent: "start",
            //   width: isMobile ? "100%" : "240px",
            //   display: "flex",
            // }}
          >
            <Image
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/")}
              preview={false}
              src={
                pathname === "/" || pathname === "/moderation"
                  ? "/xr-logo-white.png"
                  : "/xr-logo.png"
              }
            />
          </span>
          <span
            id="MainMenuPlaceHolder"
            style={{
              //   justifyContent: "center",
              width: "fit-content",
              //   display: "flex",
            }}
          >
            <Menu
              mode={"horizontal"}
              items={menuItems}
              selectedKeys={getSelectedKey(pathname)}
              disabledOverflow={true}
              style={{
                background: "transparent",
                minWidth: 0,
                flex: "auto",
                display: "flex",
                border: "none",
                justifyContent: "center",
                "--submenu-title-color": fontColor,
              }}
              onClick={handleNavigation}
              className="main-header-menu"
            />{" "}
          </span>
          <span
            id="MaskPlaceholder"
            style={{
              //   justifyContent: "center",
              width: "fit-content",
              display: "flex",
              align: "center",
            }}
          >
            <CartDropdownMenu />
            {marketplaceStore.metaMaskIsConnected ? (
              <img
                id="metaMaskN"
                src={MetamaskConnectedIcon}
                alt="metamask connected"
                onClick={handleDisConnect}
              />
            ) : (
              // <button
              //   style={{
              //     backgroundColor: "transparent",
              //     width: "fit-content",
              //     height: "fit-content",
              //     border: "none",
              //     outline: "none",
              //   }}
              // >
              <img
                id="metaMask"
                onClick={() => handleConnect()}
                // class="cart-icon"
                // style={{ cursor: "pointer", width: 48 }}
                src={MetamaskNotConnectedIcon}
                alt="metamask not connected"
              />
              // </button>
            )}
            <Dropdown menu={{ items: dropdownItems }}>
              {/* <Button
                style={{ width: "fit-content" }}
                type="link"
                onClick={(e) => e.preventDefault()}
              > */}
              {/* <img
                // style={{ height: "80px", width: "90px" }}
                onClick={(e) => e.preventDefault()}
                src={
                  pathname === "/" || pathname === "/moderation"
                    ? UserIconWhite
                    : UserIcon
                }
                id="user-icon"
                alt="user icon"
              /> */}
              <img
                onClick={(e) => e.preventDefault()}
                src={
                  pathname === "/" || pathname === "/moderation"
                    ? keycloak.authenticated
                      ? UserIconWhiteActive
                      : UserIconWhite
                    : keycloak.authenticated
                      ? UserIconActive
                      : UserIcon
                }
                id="user-icon"
                alt="user icon"
                style={{
                  ...(isWideScreen && { height: 50, width: 50 }),
                  cursor: "pointer",
                }}
              />
              {/* </Button> */}
            </Dropdown>
          </span>
        </Row>
      )}
    </div>
  );
};

export default observer(MainHeader);
